<div fxLayout="row" fxLayoutAlign="center center" class="card">
    <mat-card fxFlex="500px">
      <mat-card-header>
        <mat-card-title  class="mat-h2">Please provide your email address</mat-card-title>
      </mat-card-header>
      <mat-card-content>
          <mat-form-field class="full-width">
            <input matInput placeholder="Email" [(ngModel)]="email"  #emailModel="ngModel" type="email" (keydown)="onKeyDown($event)" required>
          </mat-form-field>
      </mat-card-content>
      <mat-card-actions align="end">
        <button mat-raised-button color="primary" [disabled]="!emailModel.valid" (click)="submit()">Reset password</button>
      </mat-card-actions>
  </mat-card>
  </div>